import { render, staticRenderFns } from "./ContactContributions.vue?vue&type=template&id=a6877ffc&"
import script from "./ContactContributions.vue?vue&type=script&lang=ts&"
export * from "./ContactContributions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/quebec-solidaire/qs_pointage_v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6877ffc')) {
      api.createRecord('a6877ffc', component.options)
    } else {
      api.reload('a6877ffc', component.options)
    }
    module.hot.accept("./ContactContributions.vue?vue&type=template&id=a6877ffc&", function () {
      api.rerender('a6877ffc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Contact/ContactContributions.vue"
export default component.exports